export default class {
	constructor(source, target) {
		this.source = ((source instanceof jQuery) ? source.get(0) : source);
		this.target = ((target instanceof jQuery) ? target.get(0) : target);
		this.initHandlers();
	}

	initHandlers() {
		this.tabHandler = (event) => {
			if (!event.shiftKey && (event.key === 'Tab')) {
				event.stopPropagation();
				event.preventDefault();
				window.ignoreGlobalFocusHandlers = true;
				this.target.focus();
				window.ignoreGlobalFocusHandlers = false;
				return -1;
			}
			return 1;
		};
		this.tabHandler = this.tabHandler.bind(this);
		this.shiftTabHandler = (event) => {
			if (event.shiftKey && event.key === 'Tab') {
				event.stopPropagation();
				event.preventDefault();
				window.ignoreGlobalFocusHandlers = true;
				this.source.focus();
				window.ignoreGlobalFocusHandlers = false;
			}
			return 1;
		};
		this.shiftTabHandler = this.shiftTabHandler.bind(this);
	}

	link() {
		this.source.addEventListener('keydown', this.tabHandler);
		this.target.addEventListener('keydown', this.shiftTabHandler);
	}

	unlink() {
		this.source.removeEventListener('keydown', this.tabHandler);
		this.target.removeEventListener('keydown', this.shiftTabHandler);
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/focus/connector.js